import { ADD_TOTAL_SUCCESS, ADD_TOTAL_FAIL } from "../actions/_actionType";

export default function survey(
  state = {
    error: false,
    success: false,
    message: "",
  },
  action
) {
  switch (action.type) {
    case ADD_TOTAL_SUCCESS:
      return {
        ...state,
        success: true,
        message: "",
      };
    case ADD_TOTAL_FAIL:
      return {
        ...state,
        success: false,
        error: true,
        message: action.message,
      };
    default:
      return state;
  }
}
